import { InstanceReference } from "./InstanceReference";
import { Euler, Matrix4, Vector3 } from "three";
import { SceneObject } from "../renderer/SceneObject";

/** A model that owns reusable instance slots and exposes per-slot transforms to {@link InstanceReference}. */
export interface Instanceable {

    nextInstance(): InstanceReference<SceneObject>;

    removeInstanceAt(index: number): void;

    isInstanceActive(index: number, reference: InstanceReference<Instanceable>): boolean;

    getMatrixAt(index: number, matrix?: Matrix4): Matrix4;

    setMatrixAt(index: number, matrix: Matrix4): void;

    setInstanceVisibleAt(index: number, visible: boolean): void;

    setPositionRotationScaleAt(index: number, position?: Vector3, rotation?: Euler, scale?: Vector3): void;

    setPositionAt(index: number, position: Vector3): void;

    getPositionAt(index: number, vector?: Vector3): Vector3;

    setRotationAt(index: number, rotation: Euler): void;

    getRotationAt(index: number, euler?: Euler): Euler;

    setScaleAt(index: number, scale: Vector3): void;

    getScaleAt(index: number, vector?: Vector3): Vector3;

}

export function isInstanceable(obj: any): obj is Instanceable {
    return 'nextInstance' in obj;
}
